<template>
    <header>
        <div class="header-inner is-fixed transition"
             :class="{'header-visible-top': isHeaderAttachedTop}">

            <div class="nav-wrapper">
                <v-nav @OnHeaderElementFocus="OnHeaderElementFocus"></v-nav>
            </div>
        </div>
    </header>
</template>

<script>
import vNav from '@/components/layout/header/Nav';

export default {
    name: 'AppHeader',

    components: {
        vNav,
    },

    data: function () {
        return {
            static: {
                desktopHeight: 80, // Header height + border
                mobileHeight: 56, // Header height + border
            },

            prevScrollPos: 0,
            currentScrollPos: 0,
            height: 56,
            buffer: 0,
            isHeaderAttachedTop: true,
            isHeaderVisible: true,

            navToggleState: false,
        }
    },

    methods: {
        OnHeaderElementFocus() {
            let positionY = document.documentElement.scrollTop;

            if (positionY > 0 && !this.isHeaderVisible) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        },

        onSpawn() {
            this.heightLogic();
        },

        onWindowScroll() {
            this.headerLogic();
        },

        onWindowResize() {
            let _this = this;

            window.onresize = function () {
                _this.heightLogic();
            }
        },

        heightLogic() {
            let x = window.innerWidth;

            if (x <= 992) {
                this.height = this.static.mobileHeight;
            } else {
                this.height = this.static.desktopHeight;
            }
        },

        headerLogic() {
            this.prevScrollPos = window.pageYOffset;

            let _this = this;
            window.onscroll = function () {
                _this.currentScrollPos = window.pageYOffset;

                if (_this.prevScrollPos < _this.currentScrollPos) {
                    // Scrolling down.

                    // Transition unblock when scrolling down near top.
                    if (_this.currentScrollPos > (_this.height + _this.buffer)) {
                        _this.isHeaderAttachedTop = false;
                    }
                } else {
                    // Scrolling up.

                    // Transition block when scrolling up.
                    if (_this.currentScrollPos <= (_this.height + _this.buffer)) {
                        _this.isHeaderAttachedTop = true;
                    }
                }
                _this.isHeaderVisible = false;

                // Change top positioning on header to trigger transition.
                if (_this.prevScrollPos > _this.currentScrollPos) {
                    document.getElementsByClassName("header-inner")[0].style.top = "0";
                    _this.isHeaderVisible = true;
                } else if (_this.currentScrollPos > (_this.height + _this.buffer)) {
                    _this.isHeaderVisible = false;
                    document.getElementsByClassName("header-inner")[0].style.top = `-${_this.height}px`;
                }

                _this.prevScrollPos = _this.currentScrollPos;
            }
        },

    },

    mounted() {
        this.onWindowScroll();
        this.onWindowResize();
        this.onSpawn();
    },
}
</script>

<style scoped lang="scss">
  @import "@/assets/scss/components/layout/header/appHeader";
</style>
